import React from "react";
import { createRoot } from "react-dom/client";

import "./index.css";
import "./assets/fonts/inter-v12-latin-300.woff2";
import "./assets/fonts/inter-v12-latin-600.woff2";
import "./assets/fonts/inter-v12-latin-regular.woff2";
import App from "./App";

const root = document.getElementById("root");
const rootInstance = createRoot(root);
rootInstance.render(<App />);
